// extracted by mini-css-extract-plugin
export default {"variantsContainer":"QuestionImgQuiz_variantsContainer__N5BX7","blockImgQuestion":"QuestionImgQuiz_blockImgQuestion__k2lUH","variants":"QuestionImgQuiz_variants__xzHgg"};